import type {FooterLeftActionProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';

export interface AiPromptBoxUploadsProps extends FooterLeftActionProps {
  renderAttachmentTooltip?: boolean;
  defaultTooltipText?: string;
}

export enum AttachmentOptionType {
  FROM_DEVICE = 'fromdevice',
  CAPTURE = 'capture',
  MY_UPLOADS = 'myuploads',
  MY_DESIGN = 'mydesign',
  TEMPLATES = 'templates',
}
